var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { List } from "../../List";
import { patch, useKeyboardNavigation } from "./hooks";
export const NavigationList = (_a) => {
    var { defaultCurrent = 0, onItemSelect, children } = _a, props = __rest(_a, ["defaultCurrent", "onItemSelect", "children"]);
    const { current, idle } = useKeyboardNavigation(defaultCurrent, children, onItemSelect);
    return (React.createElement(List, Object.assign({ onItemSelect: onItemSelect }, props), patch(children, (oldProps) => {
        if ("index" in oldProps) {
            const { index } = oldProps;
            return { interactive: !idle, selected: current === index };
        }
        return oldProps;
    })));
};
